<!--
// app/components/Shared/icons/TikTokIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  profileLink?: string;
};

withDefaults(defineProps<Props>(), {
  width: 20,
});
</script>

<template>
  <a :href="profileLink" target="_blank">
    <svg :width="width" :height="height" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9313 0.487793H9.56008V14.1137C9.56008 15.7372 8.26347 17.0708 6.64988 17.0708C5.03628 17.0708 3.73965 15.7372 3.73965 14.1137C3.73965 12.5192 5.00747 11.2145 6.56345 11.1566V7.73562C3.13456 7.79358 0.368408 10.6058 0.368408 14.1137C0.368408 17.6507 3.19218 20.4918 6.6787 20.4918C10.1652 20.4918 12.9889 17.6216 12.9889 14.1137V7.12678C14.2568 8.05452 15.8127 8.60535 17.4551 8.63436V5.21337C14.9195 5.1264 12.9313 3.03902 12.9313 0.487793Z"
        fill="currentColor"
      />
    </svg>
  </a>
</template>

<style scoped></style>
